import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';
import useOutsideClick from "./useOutsideClick";

const AddToCart = (props) => {

  const ref = useRef()
  const [phase, setPhase] = useState(1)
  const [count, setCount] = useState(0)
  const [disabled, setDisabled] = useState(0)

  const add = (id, minus) => {
    if (minus === true || props.stockTag === true || (props.stockTag === false && props.stock > count)) {
      if(count !== 0 || minus !== true){
        props.add(id, minus)
        setCount(minus ? count - 1 : count + 1)
        setPhase(2)
      }
    }
  }

  useEffect(() => {disableButtons()}, [count]);

  const disableButtons = () => {
    if (count === 0 )
      setDisabled(1)
    else if (props.stockTag === false && props.stock === count)
      setDisabled(2)
    else
      setDisabled(0)
  }

  useOutsideClick(ref, () => {
    if (phase === 2)
      count === 0 ? setPhase(1) : setPhase(3)
  })

  let c = ''
  switch (phase) {
    case 1:
      if (props.stock === 0 || props.availableToDays <= 0) {
        c = <button className="sold">Nedostupno</button>
      } else {
        c = <button className="add_to_basket" onClick={() => add(props.id)}>Dodaj u košaricu</button>
      }
      break;
    case 2:
      c = <Fade bottom duration={300}>
            <div className="plus_minus_holder">
              <button className={disabled === 1 ? "round disabled": "round"} onClick={() => add(props.id, true)}>-</button>
              <Flash spy={count}><p>{count}{props.unit}</p></Flash>
              <button className={disabled === 2 ? "round disabled": "round"} onClick={() => add(props.id)}>+</button>
            </div>
            <button className="black" onClick={() => setPhase(3)}>Spremi</button>
          </Fade>
      break;
    case 3:
      c = <Fade>
      <button className="added" onClick={() => setPhase(2)}>Dodano <span>{count}{props.unit}</span></button>
      <a href="/kosarica" className="go_to_basket"> košarica
        <svg height="17" viewbox="0 0 29.135 17" width="29.135">
          <g fill="none" stroke-linecap="corner" stroke-linejoin="corner" stroke-miterlimit="10" stroke-width="1.5" stroke="#fff" transform="matrix(1.2125 0 0 1.2125 -4.8329 -10.901)">
            <polyline points="21 10 27 16 21 22"></polyline>
            <line x1="27" x2="5" y1="16" y2="16"></line>
          </g>
        </svg>
      </a>
      </Fade>
      break;
    default:
  }

  return <div style={{width: '100%'}} ref={ref}>{c}</div>

}

export default AddToCart



// WEBPACK FOOTER //
// app/frontend/components/AddToCart.jsx